export class EmailAddress {
  public address!: string;
  public displayName!: string;

  constructor(address: string, displayName: string) {
    this.address = address;
    this.displayName = displayName;
  }
}
